var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-mailbox-selected"},[_c('div',{staticClass:"lottie-container"},[_c('LottieSelectMailbox',{staticClass:"lottie-clean",attrs:{"loop":true,"autoplay":true}})],1),_c('p',[_vm._v(_vm._s(_vm.$t('select_mailbox')))])])}
var staticRenderFns = []

export { render, staticRenderFns }